import React from 'react';
import { useEffect, useState } from 'react';
import { Box, Typography } from "@mui/material";
import { models } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import axios from 'axios';
import { get } from 'lodash';
import '../../powerbi/SiMSPowerBiEmbedComponent.css';
import {
  POWERBI_REPORT_ID_QRP,
  POWERBI_GROUP_ID_QRP,
  POWERBI_DATASET_ID_QRP,
  API_URL,
} from '@/config/env';

const QuotaRunningPeriod = () => {
   
        const [loading, setLoading] = useState(true);
         const [error, setError] = useState(null);
         const [accessToken, setAccessToken] = useState(null);
         const [pbiObj, setPbiObj] = useState(null);
         const [powerbireportId, setReportId] = useState(null);
         const [powerbidatasetId, setDatasetId] = useState(null);
         const [embedToken, setEmbedToken] = useState(null);
         const [datasetDetails, setDatasetDetails] = useState(null);
         const [embedConfig, setEmbedConfig] = useState(null);
         const [embedUrl, setEmbedUrl] = useState(null);
         const [embedType, setEmbedType] = useState(null);
         const [embedId, setEmbedId] = useState(null);
         const [embedSettings, setEmbedSettings] = useState(null);
         const [embedBackground, setEmbedBackground] = useState(null);

         const reportId = POWERBI_REPORT_ID_QRP;
         const groupId = POWERBI_GROUP_ID_QRP;
         const datasetId = POWERBI_DATASET_ID_QRP;
     
        useEffect(() => {
            const autherization = localStorage.getItem("data");
            const data = JSON.parse(autherization);
            const email= data.email;
            const userId= data.userId;
            console.log('email from local storage for quota modifications report: ' + email);
            //alert(email);
            const fullUrl = `${API_URL}PowerBI/GetPowerBIEmbedTokenQuotaRunningPeriod?email=${email}`;
        
            fetch(fullUrl, {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                email: email,
                
              })
            })
            .then(response => response.json())
            .then(data => {
              console.log('Success:', data);
              setEmbedToken(data.token);
            }
            )
            .catch((error) => {   
              console.error('Error:', error);
              setError(error);
            }
            );
          }, []);


    return (
        <div>
             <div id="powerbi-embed-container">
                            <PowerBIEmbed 
                               embedConfig={{
                                  type: 'report',
                                  id: reportId,
                                  embedUrl: `https://app.powerbi.com/reportEmbed?reportId=${reportId}&groupId=${groupId}`,
                                  
                                  accessToken:  embedToken,
                                  datasetId: datasetId, 
                                  tokenType: models.TokenType.Embed, 
                                  settings: {
                                    filterPaneEnabled: false,
                                              navContentPaneEnabled: false,
                                  },
                                  background: models.BackgroundType.Transparent,
                               }}
                               eventHandlers = {
                                new Map([
                                    ['loaded', function () {console.log('Report loaded');}],
                                    ['rendered', function () {console.log('Report rendered');}],
                                    ['error', function (event) {console.log(event.detail);}],
                                    ['visualClicked', () => console.log('visual clicked')],
                                    ['pageChanged', (event) => console.log(event)],
                                ])
                            }
                            cssClassName = { "bi-embedded" }
                            getEmbeddedComponent = { (embeddedReport) => {
                              window.report = embeddedReport; // save report in window object
                          }}                            
                            />
                         
                          </div> 
        </div>
    );
};

export default QuotaRunningPeriod;